import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, Image, Icon } from 'semantic-ui-react';
import { setItemToCart, removeItemFromCart, setItemToConstruction } from '../../../actions';
import CurrencyFormat from '../../general/CurrencyFormat';

import './CartItem.scss';

const generateSelections = item => {
    return item.selections.length > 0
        ? `${item.selections.map(sub => {
            return `${sub.name} ${sub.selections.length > 0
                ? `(${sub.selections.map(s => `${s.name}`).join(', ')})`
                : ''}`;
        }).join(', ')}`
        : '';
};

const isMobile = () => {
    return window.innerWidth <= 768;
};

const CartItem = ({ item, animate, readOnly }) => {
    const dispatch = useDispatch();

    return (
        <Card.Content className={`pi-cart-item ${readOnly ? 'readonly' : ''} ${animate && !isMobile ? 'animate' : ''}`}>
            <div className="main-content">
                <div className="item-description" style={{ margin: `0 ${item.imageUrl ? '0px' : '13px'}` }}>
                    {item.imageUrl && <Image src={item.imageUrl} />}
                    <div>
                        {item.name}
                        <p>{generateSelections(item)}</p>
                    </div>
                </div>
                <div className="item-price">
                    <CurrencyFormat amount={item.price} />
                </div>
            </div>
            {!readOnly && <div className="actions">
                <Icon
                    name="add"
                    circular={isMobile()}
                    inverted={isMobile()}
                    color={isMobile() ? "green" : undefined}
                    onClick={() => dispatch(setItemToCart({ ...item.cartItem, index: undefined }, false))}
                />
                <Icon
                    name="pencil"
                    circular={isMobile()}
                    inverted={isMobile()}
                    color={isMobile() ? "blue" : undefined}
                    onClick={() => dispatch(setItemToConstruction(item.cartItem))} />
                <Icon
                    name="trash"
                    circular={isMobile()}
                    inverted={isMobile()}
                    onClick={() => dispatch(removeItemFromCart(item.cartItem))}
                />
            </div>}
        </Card.Content>
    );
};

CartItem.propTypes = {
    item: PropTypes.object,
    readOnly: PropTypes.bool,
    animate: PropTypes.bool,
};

export default CartItem;